import { Component, EventEmitter, Input, ViewChild, OnInit, Output } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Utilities } from "@tylertech/shared-module";
import { ClassMetadata, ICardMetadata } from "@tylertech/tyler-api-types";

@Component({
    selector: "metadata-card-edit",
    templateUrl: "./metadataCard.edit.tmpl.html",
    standalone: false
})
export class MetadataCardEditComponent implements OnInit {
    @Input()
        cardMetadata: ICardMetadata;

    @Input()
        model: any;

    @Output()
    readonly toggleEdit = new EventEmitter<void>();

    @Input()
        dense: boolean;

    @Output()
    readonly overrideSave = new EventEmitter<void>();

    @ViewChild("form") form: NgForm;

    metadata: ClassMetadata;

    loading: boolean = false;

    outlined: boolean = false;

    ngOnInit(): void
    {
        this.loading = true;
        this.initialize();
    }

    private initialize(): void
    {
        this.metadata = this.cardMetadata.EditMetadata;
        if (!this.metadata) this.metadata = this.cardMetadata.ViewMetaData;
        this.loading = false;
    }

    formIsValid(): boolean
    {
        return Utilities.IsNullOrUndefined(this.form) ? true : !this.form.invalid;
    }

    cancel(): void
    {
        this.toggleEdit.emit();
    }

    save(): void
    {
        this.overrideSave.emit();
    }
}
